import Vue from 'vue';

/**
 * List of default directives to be
 * imported into the project globally
 *
 * @type {object}
 */
export const defaultDirectives = {};

/**
 * Load global Vue Directives
 * usage: <input v-directive> e.g. <input v-datepicker>
 */
export function loader() {
    Object.keys(defaultDirectives).forEach((directive) => {
        Vue.directive(directive, defaultDirectives[directive]);
    });
}
